//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import update              from 'immutability-helper';
import { MembershipTypes } from '@/store/actions/membership';

const initialState = {
    options: [],
};

const membershipFetchSucceeded = (action, state) => {
    return update(state, {
        options: {
            $set: action?.options ?? [],
        },
    });
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // @formatter:off
        case MembershipTypes.FETCH_MEMBERSHIP_SUCCEEDED: return membershipFetchSucceeded(action, state);
        default:                                         return state;
        // @formatter:on
    }
}
